import { NEGOCIOS } from './negocios'

export const aliasSistemas = {
  "home": "landing-ecommerce",
  "neumaticos": "landing-neumaticos",
  [NEGOCIOS.ACEITES]: "landing-aceites",
  "baterias": "landing-baterias",
  "frenos": "landing-frenos",
  [NEGOCIOS.AFINAMIENTO]: "landing-afinamiento",
  "amortiguadores": "landing-amortiguadores",
  [NEGOCIOS.TRENDELANTERO]: "landing-trendelantero",
  "alineacion": "landing-alineacion",
  "balanceo": "landing-balanceo",
  [NEGOCIOS.GEOMETRIA]: "landing-geometria",
  [NEGOCIOS.KILOMETRAJE]: "landing-kilometraje",
  "higienizacion": "landing-higienizacion",
  "fluidos": "landing-fluidos",
  [NEGOCIOS.ELECTRICO]: "landing-electrico",
  "accesorios": "landing-accesorios",
  [NEGOCIOS.REVISIONTECNICA]: "landing-gestion-revision-tecnica",

  //locales
  "local-antofagasta":"landing-antofagasta",
  "local-chicureo":"landing-chicureo",
  "local-colon":"landing-colon",
  "local-concepcion":"landing-concepcion",
  "local-diagonal":"landing-diagonal",
  "local-estoril":"landing-estoril",
  "local-irarrazaval":"landing-irarrazaval",
  "local-laflorida":"landing-laflorida",
  "local-laserena":"landing-laserena",
  "local-maipu":"landing-maipu",
  "local-penalolen":"landing-penalolen",
  "local-puertomontt":"landing-puertomontt",
  "local-rancagua":"landing-rancagua",
  "local-vicmack":"landing-vicmack",
  "local-vina":"landing-vina",
  "local-vitacura":"landing-vitacura",
};
